var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isMaster)?_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-body"},[_vm._v("\n\t\t\tCircuitos Encontrados "),_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.getTotal))])])]):_c('placeholder')],1)}
var staticRenderFns = []

export { render, staticRenderFns }